import React from 'react';

export function ArrowUp(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8752 6.2827L16.7805 6.19226L10.4313 0.750079C9.65319 0.0831307 8.52556 0.046078 7.70862 0.638921L7.56782 0.750079L1.21861 6.19226C0.715416 6.62356 0.657142 7.38112 1.08845 7.88432C1.491 8.35396 2.17776 8.43603 2.67665 8.09422L2.78051 8.01447L7.79958 3.71256L7.79956 20.5796C7.79956 21.2423 8.33681 21.7796 8.99956 21.7796C9.62088 21.7796 10.1319 21.3074 10.1934 20.7022L10.1996 20.5796L10.1996 3.71256L15.2186 8.01447C15.6883 8.41703 16.3795 8.3931 16.8202 7.97901L16.9107 7.88432C17.3132 7.41467 17.2893 6.72344 16.8752 6.2827Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
